import { CARDS_DATA } from "./cards";

export const SAND_BOX_DATA = {
  cardsView: CARDS_DATA,
};
